import { render, staticRenderFns } from "./viewfileActivities.vue?vue&type=template&id=0d5b564e&scoped=true&"
import script from "./viewfileActivities.vue?vue&type=script&lang=js&"
export * from "./viewfileActivities.vue?vue&type=script&lang=js&"
import style0 from "./viewfileActivities.vue?vue&type=style&index=0&id=0d5b564e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d5b564e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\datacenter_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0d5b564e')) {
      api.createRecord('0d5b564e', component.options)
    } else {
      api.reload('0d5b564e', component.options)
    }
    module.hot.accept("./viewfileActivities.vue?vue&type=template&id=0d5b564e&scoped=true&", function () {
      api.rerender('0d5b564e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/gmTool/activities/components/components/viewfileActivities.vue"
export default component.exports